namespace SPA {
	export namespace Realtor {
		interface IBidderOptions extends Backbone.ViewOptions<SPA.Contact>
		{
			ObjectNumber: string;
		}

		export class BidderView extends Backbone.View<SPA.Contact> {
			private ObjectNumber: string;
			private Contacts: SPA.Contacts.ContactList;

			public constructor(options: IBidderOptions) {
				super(options);

				this.ObjectNumber = options.ObjectNumber;
				this.Contacts = app.getContactManager().getContacts();
			}

			public preinitialize(options: IBidderOptions): void
			{
				options.tagName = 'fieldset';
			}

			public initialize(options?: Backbone.ViewOptions<SPA.Contact>): void {
				this.listenTo(this.Contacts, 'change', this.render);
			}

			public render()
			{
				const btnAdd = $('<button class="btn btn-default" type="button"><i class="fas fa-plus-circle"></i> Neuer Kaufinteressent</button>')
					.on('click', (e) => {
						const contactModal = new SPA.Contacts.Modal(app.getAuthenticationManager().getCompany());

						// Set modal title
						contactModal.setTitle('Neuen Kaufinteressenten anlegen');

						// Build and append the new "customer" form
						contactModal.setObjectNumber(this.ObjectNumber || '');
						contactModal.setType('bidder');

						contactModal.getForm().find('.modal .btn-primary').text('Speichern');

						// show the form
						contactModal.show();
					});

				const contactAutocomplete = ui.$$.input().addClass('form-control')
					.attr({
						'name': 'address.search',
						'placeholder': 'Kaufinteressent suchen',
						'data-type': 'bidder',
					});

				// Todo Workaround for now, uses collection listenTo event
				const bidderAutocomplete = new SPA.Contacts.Autocomplete(contactAutocomplete, this.ObjectNumber, () => this.render());

				const html = $('<legend>Kaufinteressenten</legend>')
					.add(ui.$$.div().addClass('row')
						.append(SPA.gui.Bootstrap.Column(['col-sm-6'], bidderAutocomplete.el()))
						.append(SPA.gui.Bootstrap.Column(['col-sm-4'], btnAdd))
					)
					.add(ui.$$.div().addClass('row')
						.append(this.BuildList($('<div class="col-sm-12">'))
						)
					);

				this.$el.empty().append(html);

				return this;
			}

			private BuildList(root: JQuery)
			{
				const contactList = app.getContactManager().getItems(this.ObjectNumber, 'bidder');
				for (const contact of contactList)
				{
					const bidderStattus = contact.StatusList.bidder(this.ObjectNumber);
					if (bidderStattus.length === 0) {
						continue;
					}

					const statusRow = $('<div style="margin: 5px 0">');

					for (const status of bidderStattus)
					{
						const statusRowView = new SPA.Contacts.StatusRowView({model: status, mode: 'contact'});
						root.append(statusRow.append(statusRowView.render().$el));
					}
				}

				return root;
			}
		}
	}
}
